<template>
  <div id="app">
    <headerview></headerview>
    <router-view />
    <footerView></footerView>
  </div>
</template>

<script>
import headerview from "@/components/header"; // 头部组件
import footerView from "@/components/footer"; // 页脚组件
export default {
  name: 'App',
  components: {
    headerview, footerView
  }
}
</script>

<style>
* {
  margin: 0;
  padding: 0;
  list-style: none;
  text-decoration: none;
}

.huanneng {
  margin-top: 60px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue